export const DhlEcommerceService = Object.freeze({
  PacketInternational: '156',
  PacketPlusInternational: '158',
  GlobalMailPacketIpa: '159',
  ParcelInternationalStandard: '164',
  ParcelInternationalDirectDdp: '165',
  ParcelInternationalDirectDdu: '166',
});
